import React, { useMemo } from 'react';
import zxcvbn from 'zxcvbn';
import './PasswordStrength.css';

const LABELS = ['Muy débil', 'Débil', 'Regular', 'Buena', 'Fuerte'];

/**
 * Indicador de fortaleza de contraseña basado en zxcvbn.
 * Muestra una barra de 5 segmentos coloreada según el score (0-4) y un
 * feedback breve cuando la password es débil. No renderiza nada si la
 * password está vacía.
 *
 * @param {{ password: string }} props
 */
const PasswordStrength = ({ password = '' }) => {
  const result = useMemo(() => (password ? zxcvbn(password) : null), [password]);

  if (!password) return null;

  const score = result.score; // 0 (muy débil) … 4 (fuerte)
  const warning = result.feedback.warning;

  return (
    <div className="password-strength" data-score={score}>
      <div className="password-strength__bar" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className={`password-strength__segment ${i <= score ? 'is-active' : ''}`}
          />
        ))}
      </div>
      <div className="password-strength__meta">
        <span className="password-strength__label">{LABELS[score]}</span>
        {warning && score < 2 && (
          <span className="password-strength__warning">{warning}</span>
        )}
      </div>
    </div>
  );
};

export default PasswordStrength;
